import { render, staticRenderFns } from "./innovation.vue?vue&type=template&id=5a5fb905&"
import script from "./innovation.vue?vue&type=script&lang=js&"
export * from "./innovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../blsguanfang_blszf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports